<template>
  <div class="similarity">
    <div class="message">
      <template v-if="tierRef === 'high'">This file is very similar to the last file used to sync this tree.</template>
      <template v-else-if="tierRef === 'medium'">This file is somewhat similar to the last file used to sync this tree.</template>
      <template v-else>This file is <span class="warning-text">very different</span> from the last file used to sync this tree.</template>
    </div>
    <div class="comparison">
      <template v-if="lastPersonCount !== undefined">
        <div class="name">People in the last file used:</div>
        <div class="value">{{ lastPersonCount.toLocaleString() }}</div>
      </template>
      <div class="name">People in this file:</div>
      <div class="value">{{ comparison.sourcePersonCount?.toLocaleString() }}</div>
      <div class="name">Random person matches:</div>
      <div class="value">{{ comparison.matchRateText }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.similarity {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.warning-text {
  background-color: var(--bs-warning);
  padding: 0 0.25rem;
}

.comparison {
  margin-left: 1rem;
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 2rem;

  .name {
    color: #888;
  }
}
</style>

<script setup lang="ts">
import { computed } from 'vue'
import { WorkspaceComparison } from './SyncSessionModel'

const props = defineProps<{
  comparison: WorkspaceComparison
  lastPersonCount?: number
}>()

const tierRef = computed(() => props.comparison.similarityTo(props.lastPersonCount))
</script>
